import { useMe } from '@/shared/hooks/useMe'
import { useQuery } from '@tanstack/react-query'
import { resolveApiUrl } from '@/shared/utils/requestsUtils'
import type { GetCompanyConfigAttributes } from '../companyConfigServices'
import { requestService } from '@/shared/services/requestServices'

export const useCompanyConfig = () => {
    const { companyId } = useMe()

    return useQuery({
        queryKey: ['company-config', companyId],
        queryFn: () => {
            const url = resolveApiUrl('internal.getCompanyConfig', { variables: { companyId } })
            return requestService<GetCompanyConfigAttributes>(url)
        },
        // About 40 components read the config. A mount reads the cache, as useCompany did when it carried the config.
        refetchOnMount: false
    })
}

/** The beneficiary stays hidden until the company config has loaded and enables the funnel. */
export const useIsBeneficiaryRepaymentFunnelEnabled = (): boolean => {
    const companyConfig = useCompanyConfig()

    return companyConfig.isSuccess && !!companyConfig.data?.body?.beneficiaryRepaymentFunnel?.enabled
}
